const ActionType = {
  SET_COMPANY: 'SET_COMPANY',
  FETCH_COMPANY: 'FETCH_COMPANY',
};

export default ActionType;
